/** True when `/login` was reached mid SSO/OIDC handoff (SSRS report SSO via
 * `sso`/`sig`, or CRMLite via `interaction_uid`) rather than by a user who
 * actually needs to type in credentials. Callers use this to decide whether
 * a pre-redirect loading state should look like a login form at all. */
export const isSsoHandoffRequest = (search: string): boolean => {
  const params = new URLSearchParams(search)
  const hasSsoAndSig = !!params.get('sso') && !!params.get('sig')
  const hasInteractionUid = !!params.get('interaction_uid')
  return hasSsoAndSig || hasInteractionUid
}
